exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-editor__container[data-v-0dcc68cc]{width:100%;height:100%}.image-editor__container .image-editor__main[data-v-0dcc68cc]{width:100%;height:calc(100% - 100px)}.image-editor__container .image-editor__footer[data-v-0dcc68cc]{height:100px!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0dcc68cc","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/image-filter/image-editor/image-editor.vue
// module id = 202
// module chunks = 0